import { iIconProps } from '../icon';

export default function UserIcon({ size, ...props }: iIconProps): JSX.Element {
    return (
        <svg width={size} height={size} viewBox='0 0 24 24' {...props}>
            <path
                d='M6.22 14.62c-1.51 1.05-5.46 3.2-3.05 5.88 1.18 1.31 2.49 2.25 4.13 2.25h9.4c1.65 0 2.96-.94 4.13-2.25 2.41-2.69-1.55-4.83-3.05-5.88-3.54-2.46-8.03-2.46-11.56 0M16.99 6.24c0 2.76-2.23 4.99-4.99 4.99S7.01 9 7.01 6.24 9.24 1.25 12 1.25s4.99 2.23 4.99 4.99'
                fill='#ffffff'
            />
        </svg>
    );
}
